import { ReactNode } from 'react';
import styled, { css } from 'styled-components';

import { Grid } from 'coreOld/elements';
import { AlignText } from 'coreOld/enums';

const alignText = {
  [AlignText.LEFT]: 'left',
  [AlignText.RIGHT]: 'right',
  [AlignText.CENTER]: 'center',
};

type HeaderItemProps = { children?: ReactNode; textAlign?: keyof typeof AlignText };

const HeaderItem = styled(Grid)<HeaderItemProps>`
  border-bottom: none;
  font:
    300 12px/1.2em 'Open Sans',
    sans-serif;
  letter-spacing: 0.02em;
  padding: 15px 0px;
  text-align: right;
  text-transform: uppercase;
  white-space: nowrap;
  display: inline-block;
  vertical-align: top;

  ${({ textAlign }) =>
    textAlign &&
    css`
      text-align: ${alignText[textAlign]};
    `}
`;

export default HeaderItem;
